// See details-disclosure.js for why setup cannot live in the constructor:
// an element may be upgraded before its children are parsed. Subclasses hook
// into onInit() rather than adding their own constructor DOM lookups.
class SearchForm extends HTMLElement {
  connectedCallback() {
    this.init();
  }

  init() {
    if (this.initialised) return;

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');
    if (!this.input || !this.input.form) {
      this.initWhenParsed();
      return;
    }

    this.initialised = true;

    this.input.form.addEventListener('reset', this.onFormReset.bind(this));
    this.input.addEventListener(
      'input',
      debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );

    this.onInit();
  }

  initWhenParsed() {
    if (this.retryQueued) return;
    this.retryQueued = true;

    const retry = () => {
      this.retryQueued = false;
      this.init();
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', retry, { once: true });
    } else {
      requestAnimationFrame(retry);
    }
  }

  // Subclass hook, called once the form's own markup is known to exist.
  onInit() {}

  toggleResetButton() {
    if (!this.resetButton) return;
    const resetIsHidden = this.resetButton.classList.contains('hidden');
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);
